module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "custom-contact-columns"
  }, [_c('div', {
    staticClass: "custom-contact-columns__bg"
  }, [_c('div', {
    staticClass: "custom-contact-columns__container"
  }, [_c('div', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.onWaypointTitle,
        options: _vm.intersectionTitleOptions
      }),
      expression: "{ active: true, callback: onWaypointTitle, options: intersectionTitleOptions }"
    }],
    staticClass: "custom-contact-columns__title",
    class: {
      "custom-contact-columns__title--active": _vm.fadeTitle
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-contact-columns__row"
  }, [_c('div', {
    staticClass: "custom-contact-columns__col-left"
  }, [_c('div', {
    staticClass: "custom-contact-columns__info-container"
  }, [_c('div', {
    staticClass: "custom-contact-columns__phone"
  }, [_c('div', {
    staticClass: "custom-contact-columns__phone--icon"
  }, [_c('Icon', {
    attrs: {
      "name": "Phone"
    }
  })], 1), _c('div', {
    staticClass: "custom-contact-columns__phone--number",
    domProps: {
      "innerHTML": _vm._s(_vm.props.phone_number)
    }
  })]), _c('div', {
    staticClass: "custom-contact-columns__email"
  }, [_c('div', {
    staticClass: "custom-contact-columns__email--icon"
  }, [_c('Icon', {
    attrs: {
      "name": "Email"
    }
  })], 1), _c('div', {
    staticClass: "custom-contact-columns__email--address",
    domProps: {
      "innerHTML": _vm._s(_vm.props.email)
    }
  })]), _c('div', {
    staticClass: "custom-contact-columns__location"
  }, [_c('div', {
    staticClass: "custom-contact-columns__location--icon"
  }, [_c('Icon', {
    attrs: {
      "name": "Pin"
    }
  })], 1), _c('a', {
    staticClass: "custom-contact-columns__location--address",
    attrs: {
      "href": _vm.props.map_link
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.address)
    }
  })])]), _c('div', {
    staticClass: "custom-contact-columns__map"
  }, [_c('iframe', {
    staticClass: "custom-contact-columns__map--map",
    attrs: {
      "src": _vm.props.map_embed_link,
      "width": "100%",
      "height": "220"
    }
  })])]), _c('div', {
    staticClass: "custom-contact-columns__col-right"
  }, [_c('ContactForm')], 1)])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78852400","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-contact-columns/custom-contact-columns.pug
// module id = 589
// module chunks = 1